import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'cy',
    fullName: 'Welsh',
    nativeName: 'Cymraeg',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Mae Rhywbeth Rhyfeddol yn Dod",
    landing_subtitle: "Mae ArgVoid yn stiwdio datblygu apiau a gemau. Cadwch diwnio, mae pethau newydd yn dod yn fuan!",
    select_language: "Dewiswch Iaith",
    search_placeholder: "Chwilio ieithoedd...",
    terms_title: "Telerau Gwasanaeth",
    policy_title: "Polisi Preifatrwydd",
    cookies_title: "Polisi Cwcis",
    terms_content: `
        <strong>1. Derbyn Termau</strong><br>
        Trwy gyrchu ArgVoid, derbynnir y Telerau Gwasanaeth hyn. Os na chytunir ar y telerau hyn, ni ddylid defnyddio'r gwasanaeth.<br><br>

        <strong>2. Defnydd Llwyfan</strong><br>
        Darperir ArgVoid a'i gymwysiadau "fel y mae" at ddibenion gwybodaeth a chreadigol. Rhaid defnyddio'r gwasanaeth at ddibenion cyfreithlon yn unig.<br><br>

        <strong>3. Ymddygiad Gwaharddedig</strong><br>
        Gwaherddir yn llwyr fanteisio ar wendidau safle, sbamio, neu geisio mynediad heb awdurdod i'r seilwaith.<br><br>

        <strong>4. Ymwadiad</strong><br>
        Gellir addasu'r platfform a'r gwasanaethau ar unrhyw adeg heb rybudd. Ni ddarperir unrhyw warant ynghylch yr amser a'r amser sydd ar gael neu argaeledd y gwasanaeth.
    `,
    policy_content: `
        <strong>1. Casgliad Gwybodaeth</strong><br>
        Nid oes angen dilysu defnyddwyr na chreu cyfrif ar y platfform ar hyn o bryd. Nid oes unrhyw wybodaeth adnabod bersonol (fel enwau neu gyfeiriadau e-bost) yn cael ei chasglu'n weithredol gan ymwelwyr.<br><br>

        <strong>2. Data Defnydd</strong><br>
        Gellir casglu dadansoddiadau sylfaenol, dienw i ddeall traffig y safle a gwella'r cymwysiadau. Nid yw'r data hwn yn gysylltiedig â hunaniaeth defnyddwyr unigol.<br><br>

        <strong>3. Gwasanaethau Trydydd Parti</strong><br>
        Gellir defnyddio darparwyr trydydd parti ar gyfer gwasanaethau cynnal a dadansoddi. Mae arferion preifatrwydd y darparwyr hyn yn rheoli'r data dienw a brosesir ar eu seilwaith.<br><br>

        <strong>4. Diogelwch Data</strong><br>
        Gweithredir mesurau diogelwch rhesymol i amddiffyn y platfform. Fodd bynnag, nid oes unrhyw ddull trosglwyddo dros y Rhyngrwyd yn gwbl ddiogel.<br><br>
    `,
    cookies_content: `
        <strong>1. Beth yw Cwcis a Storio Lleol? </strong><br>
        Mae cwcis a storfa leol porwr yn ffeiliau data bach sy'n cael eu storio ar y ddyfais i gofio dewisiadau ffurfweddu ar draws ymweliadau.<br><br>

        <strong>2. Defnydd Pwrpas</strong><br>
        Defnyddir Browser LocalStorage yn llym i arbed gosodiadau cyfluniad, megis: <br>
        - Dewisiadau iaith<br>
        - Cyfluniad rhyngwyneb defnyddiwr (e.e., gosodiadau gosodiad neu thema) <br>
        - Cais dros dro cache<br><br>

        <strong>3. Dim Olrhain</strong><br>
        Ni ddefnyddir cwcis a storfa leol at ddibenion hysbysebu neu olrhain trydydd parti. Mae'r holl ddata sydd wedi'i storio ar gyfer ymarferoldeb craidd y platfform yn unig.<br><br>

        <strong>4. Rheolaeth</strong><br>
        Gellir clirio data porwr ar unrhyw adeg trwy osodiadau'r porwr, a fydd yn ailosod unrhyw ffurfweddiadau lleol.
    `,
    cookie_consent_text: "Rydym yn defnyddio cwcis sylfaenol i sicrhau bod y wefan yn gweithredu'n gywir, megis cadw'ch sesiwn yn weithredol, arbed eich dewis iaith, a ffurfweddau personol eraill.",
    read_policy: "Darllenwch y Polisi Cwcis",
    support_title: "Cymorth Cyswllt",
    support_subject_label: "Pwnc",
    support_message_label: "Neges",
    support_submit_button: "Anfon Neges",
    support_hint: "Nodyn: Bydd hyn yn agor eich cais e-bost rhagosodedig i anfon y neges.",
    support_success_msg: "Wrthi'n agor eich ap e-bost...",
    support_error_msg: "Wedi methu ag anfon neges. Ceisiwch eto yn nes ymlaen.",
    explorer_title: "Fforiwr",
    history_title: "Hanes",
    animation_title: "Animeiddiad",
    config_title: "Cyfluniad",
    tool_mouse: "Dewiswch (Ctrl+M)",
    tool_brush: "Brws (Ctrl+B)",
    tool_brush_mode: "Modd Toglo (Solet/Clir)",
    tool_eraser: "Rhwbiwr (Ctrl+E)",
    tool_brush_size: "Addasu Maint Brwsh",
    tool_bucket: "Llenwi (Ctrl+F)",
    tool_eyedropper: "Eyedropper",
    tool_grid: "Grid (Ctrl+Shift+B)",
    tool_rotate: "Cylchdroi (Ctrl+Shift+R)",
    tool_flip_h: "Fflip H (Ctrl+Shift+H)",
    tool_flip_v: "Troi V (Ctrl+Shift+V)",
    tool_transpose: "Trawsosod (Ctrl+Shift+T)",
    label_width: "Lled",
    label_height: "Uchder",
    label_frames: "Nifer y Fframiau",
    label_animation: "Arddull Animeiddio",
    label_background_color: "Lliw Cefndir",
    label_interval: "Cyfwng",
    tool_anim_config: "Ffurfweddiad Animeiddiad",
    label_new_width: "Lled Newydd",
    label_new_height: "Uchder Newydd",
    label_apply: "Ymgeisiwch",
    label_colors: "Lliwiau",
    label_size: "Maint",
    label_tolerance: "Goddefgarwch",
    val_horizontal: "Llorweddol",
    val_vertical: "Fertigol",
    val_sequence: "Dilyniant",
    val_bounce: "Bownsio",
    val_random: "Ar hap",
    val_solid: "Solid",
    val_clear: "Clir",
    action_add_sheet: "Taflen Newydd",
    action_import: "Mewnforio",
    action_export: "Allforio",
    action_sort_projects: "Trefnu",
    sort_date_old: "Hynaf yn Gyntaf",
    sort_date_new: "Diweddaraf yn Gyntaf",
    sort_name_az: "Enw (A-Z)",
    sort_name_za: "Enw (Z-A)",
    action_new_sprite: "Sprite Newydd",
    action_new_project: "Prosiect Newydd",
    modal_save_all_title: "Arbed Pob Newid",
    modal_save_all_desc: "Dewiswch yr asedau i'w harbed:",
    modal_save_selected: "Cadw Dewiswyd",
    action_saved: "Cadwedig",
    modal_create_sprite_title: "Creu Sprite Newydd",
    modal_create_project_title: "Creu Prosiect Newydd",
    modal_add_sheet_title: "Ychwanegu Dalen Newydd",
    modal_rename_sheet_title: "Ail-enwi Dalen",
    modal_rename_sprite_title: "Ailenwi Sprite",
    modal_delete_sprite_title: "Dileu Sprite",
    modal_delete_project_title: "Dileu Prosiect",
    modal_delete_sheet_title: "Dileu Dalen",
    placeholder_sprite_name: "Enw",
    placeholder_project_name: "Enw",
    placeholder_sheet_name: "Enw",
    placeholder_new_name: "Enw Newydd",
    action_create: "Creu",
    action_add: "Ychwanegu",
    action_rename: "Ailenwi",
    action_duplicate: "Dyblyg",
    action_delete: "Dileu",
    action_cancel: "Canslo",
    confirm_delete_sprite: "Ydych chi'n siŵr eich bod am ddileu'r corlun hwn?",
    confirm_delete_project: "Ydych chi'n siŵr eich bod am ddileu'r prosiect hwn? Bydd yr holl sprites yn cael eu tynnu.",
    confirm_delete_sheet: "Ydych chi'n siŵr eich bod am ddileu'r ddalen hon?",
    err_select_sprite: "Dewiswch corlun yn gyntaf.",
    err_select_project: "Dewiswch brosiect yn gyntaf.",
    err_name_empty: "Ni all yr enw fod yn wag.",
    err_sprite_exists: "Mae corlun gyda'r enw hwnnw eisoes yn bodoli.",
    err_project_exists: "Mae prosiect gyda'r enw hwnnw eisoes yn bodoli.",
    err_no_content: "Dim cynnwys i'w gadw.",
    err_no_changes: "Dim newidiadau i'w cadw.",
    err_delete_last_sheet: "Methu dileu'r ddalen olaf.",
    err_extract_frames: "Methu echdynnu unrhyw fframiau.",
    err_indexeddb: "Wedi methu ag arbed yn lleol. Mae'n bosibl na fydd eich porwr yn cefnogi IndexedDB.",
    msg_upload_success: "Llwytho i fyny yn llwyddiannus: {0}",
    msg_upload_failed: "Methwyd uwchlwytho: {0}",
    msg_save_success: "Arbed yn llwyddiannus.",
    msg_saving: "Wrthi'n cadw...",
    msg_multi_save_result: "{0} ased wedi'u cadw. {1} methiannau.",
    menu_title: "Bwydlen",
    menu_save: "Arbed",
    menu_save_all: "Arbed Pawb",
    menu_support: "Cymorth Cyswllt",
    label_local_storage: "Storio Lleol",
    label_sign_in: "Mewngofnodwch",
    modal_export_title: "Allforio Sprite",
    label_filename: "Enw ffeil",
    label_format: "Fformat",
    action_export_confirm: "Allforio",
};

export default translations;
